import { Component, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material";
import { Router } from "@angular/router";
import { SelectParkingDialogComponent } from "src/app/shared/select-parking-dialog/select-parking-dialog.component";

declare interface RouteInfo {
  path: string;
  title: string;
  icon: string;
  class: string;
}
export const ROUTES: RouteInfo[] = [
  {
    path: "../application/windows-services",
    title: "Windows Services",
    icon: "icon-app",
    class: ""
  },
  {
    path: "../application/sql-server-databases",
    title: "Sql Server Databases",
    icon: "icon-paper",
    class: ""
  },  
  {
    path: "../application/parking-desktops",
    title: "Parking Desktops",
    icon: "icon-tv-2",
    class: ""
  },
    {
    path: "../application/initial-xml-layouts",
    title: "Initial Xml Layouts",
    icon: "icon-components",
    class: ""
  },
  {
    path: "../administration/plc-commands",
    title: "PLC Command",
    icon: "icon-settings-gear-63",
    class: ""
  },
  {
    path: "../application/tablet-apps",
    title: "Tablet apps",
    icon: "icon-mobile",
    class: ""
  },
  {
    path: "../application/temp-files",
    title: "Temp Files",
    icon: "icon-watch-time",
    class: ""
  }
];

export const SubRoutes: RouteInfo[] = [
  {
    path: "../administration/clients",
    title: "Clients",
    icon: "icon-single-02",
    class: ""
  },
  {
    path: "../administration/technician",
    title: "Technicians",
    icon: "icon-user-run",
    class: ""
  },
  {
    path: "../administration/cards",
    title: "Cards",
    icon: "icon-badge",
    class: ""
  },
  {
    path: "../administration/configs",
    title: "Configs",
    icon: "icon-settings",
    class: ""
  },
  {
    path: "../administration/knowledge-base",
    title: "Knowledge Base",
    icon: "icon-bank",
    class: ""
  },
  ,
  {
    path: "../administration/parking-info",
    title: "Parking Info",
    icon: "icon-components",
    class: ""
  },
  {
    
    path: "../administration/reports",
    title: "Reports",
    icon: "icon-book-bookmark",
    class: ""
  },
  {
    path: "../administration/messages",
    title: "Messages",
    icon: "icon-email-85",
    class: ""
  }
];

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"]
})

export class SidebarComponent implements OnInit {
  menuItems: RouteInfo[];
  parkingMenuSubItems: RouteInfo[];
    
  constructor(public dialog: MatDialog, private router: Router) {}

  ngOnInit() {
    this.menuItems = ROUTES.filter(menuItem => menuItem);
    this.parkingMenuSubItems = SubRoutes.filter(menuItem => menuItem);
  }

  isMobileMenu() {
    if (window.innerWidth > 991) {
      return false;
    }
    return true;
  }

  openConfirmDialog(path) {
    if(path.includes('tech')) {
      this.router.navigate(["administration/technician"]);
    } else {
      let ref = this.dialog.open(SelectParkingDialogComponent, {
        width: '30%',
        height: '150px',
        data: {
          message: "Please select parking",
          path: path
        }
      });
      ref.componentInstance.onClickedConfirmButton.subscribe((selectedParking) => {   
        if(!selectedParking.id) {
          selectedParking.id = "all";
          selectedParking.name = "all";
        }
        
        this.router.navigate([path + "/" + selectedParking.id + "/" + selectedParking.name]);  
        this.dialog.closeAll();
      });
    }
  }
}
